import React from 'react'
import { HeadingText } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'

import { recentActivityTitle } from './activityHeading.css'

const ActivityHeading = () => (
  <HeadingText
    size="sm"
    as="h2"
    className={recentActivityTitle}
    data-testid="activity-heading"
  >
    <Message id="activity.recentActivity" />
  </HeadingText>
)

export default ActivityHeading
